import React from 'react';
import AwardAccountSummaryGLCard from './components/AwardAccountSummaryGLIndex.jsx';

const AwardAccountSummaryGL = () => <AwardAccountSummaryGLCard />;

export default AwardAccountSummaryGL;
